import { __awaiter, __generator } from "tslib";
import axiosInstance from "../axiosInstance";
import endpoints from "../endpoints";
export var sendOtp = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.post(endpoints.api.sendOtp, { email: email })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var verifyOtp = function (email, otp) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.post(endpoints.api.verifyOtp, { email: email, otp: otp })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var resendOtp = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.post(endpoints.api.resendOtp, { email: email })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var googleOAuth = function (provider) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.get("".concat(endpoints.api.googleOAuth))];
            case 1: 
            //return await axiosInstance.post(endpoints.api.sendOtp, { email });
            return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var verifyEmailFromMail = function (email, token) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.post(endpoints.api.verifyEmailFromMail, {
                    email: email,
                    token: token,
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getProfileCompletionStatus = function (email) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.get(endpoints.api.profileCompletionStatus, {
                    params: { email: email },
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var updateProfile = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.post(endpoints.api.updateProfile, data)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var homeToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.post(endpoints.api.homeToken)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/*

export const resendOtp = async (email: string) => {
  return await axiosInstance.post(endpoints.resendOtp, { email });
};

export const createProfile = async (profileData: any) => {
  return await axiosInstance.post(endpoints.createProfile, profileData);
};

export const getProfile = async () => {
  return await axiosInstance.get(endpoints.getProfile);
}; */
